// src/app/core/shape-data.service.ts
import { Injectable } from '@angular/core';
import { NodeShapeDTO } from '../models/ShaclShapeSummary';

@Injectable({
  providedIn: 'root'
})
export class ShapeDataService {
  private selectedShape?: NodeShapeDTO;
  private shapeName?: string;
  private shapeDescription?: string;

  setSelectedShape(shape: NodeShapeDTO, name?: string, description?: string): void {
    this.selectedShape = shape;
    this.shapeName = name;
    this.shapeDescription = description;
  }

  getSelectedShape(): NodeShapeDTO | undefined {
    return this.selectedShape;
  }

  getShapeName(): string | undefined {
    return this.shapeName;
  }

  getShapeDescription(): string | undefined {
    return this.shapeDescription;
  }

  clearSelectedShape(): void {
    this.selectedShape = undefined;
    this.shapeName = undefined;
    this.shapeDescription = undefined;
  }
}

